import styles from "@/components/pages/onboarding/components/styles/onboarding-input.module.scss";
import StyledInput from "@/components/common/input/styled-input";
import UnfilledButton from "@/components/common/unfilled-button";
import { useOnboarding } from "@/components/pages/onboarding/providers/onboarding-provider";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import Loader from "@/components/common/loader";

const OnboardingInput = () => {
  const { activeSurvey, inputContext, setInput, handleInputSubmit } =
    useOnboarding();

  const { hideModal } = useGlobalModalContext();

  if (!inputContext) {
    return <Loader />;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.text}>{activeSurvey!.otherTitle}</div>
      <div className={styles.input_wrapper}>
        <StyledInput
          value={inputContext!.input}
          placeholder={"Type your answer here"}
          onChange={(e) => setInput(e.target.value)}
        />
        <div className={styles.next_button_wrapper}>
          <UnfilledButton
            text={"NEXT"}
            textColor={"#F9A825"}
            borderColor={"#F9A825"}
            onClick={() => {
              hideModal();
              handleInputSubmit();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OnboardingInput;
